import React from 'react'
import { Icon } from '@/design-system/atoms/Icon'
import { Button } from '@/design-system/atoms/Button'

export interface MessageActionsProps {
  onCopy?: () => void
  onEdit?: () => void
  onRegenerate?: () => void
  onToggleRaw?: () => void
  copied?: boolean
  showRaw?: boolean
  className?: string
}

/**
 * Action buttons for messages (copy, edit, regenerate, toggle raw)
 *
 * Features:
 * - Copy to clipboard
 * - Edit message (user messages only)
 * - Regenerate response (agent messages only)
 * - Toggle between raw and rendered view
 * - Visual feedback for actions
 */
export const MessageActions: React.FC<MessageActionsProps> = ({
  onCopy,
  onEdit,
  onRegenerate,
  onToggleRaw,
  copied = false,
  showRaw = false,
  className = '',
}) => {
  const iconClass = 'size-3'

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {/* Toggle Raw/Markdown View */}
      {onToggleRaw && (
        <Button
          variant="ghost"
          size="xs"
          onClick={onToggleRaw}
          title={showRaw ? 'Ver renderizado' : 'Ver raw'}
          leftIcon={
            showRaw ? (
              <Icon name="eye" size={12} />
            ) : (
              <Icon name="code" size={12} />
            )
          }
        >
          {showRaw ? 'Markdown' : 'Raw'}
        </Button>
      )}

      {/* Copy Button */}
      {onCopy && (
        <Button
          variant="ghost"
          size="xs"
          onClick={onCopy}
          title="Copiar mensagem"
          leftIcon={<Icon name="copy" size={16} className={iconClass} />}
        >
          {copied ? 'Copiado!' : 'Copiar'}
        </Button>
      )}

      {/* Edit Button (User messages) */}
      {onEdit && (
        <Button
          variant="ghost"
          size="xs"
          onClick={onEdit}
          title="Editar mensagem"
          leftIcon={<Icon name="pencil" size={12} />}
        >
          Editar
        </Button>
      )}

      {/* Regenerate Button (Agent messages) */}
      {onRegenerate && (
        <Button
          variant="ghost"
          size="xs"
          onClick={onRegenerate}
          title="Regenerar resposta"
          leftIcon={<Icon name="refresh" size={12} />}
        >
          Regenerar
        </Button>
      )}
    </div>
  )
}
